import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21c709b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-full text-base flex flex-column justify-content-center align-items-center pb-5" }
const _hoisted_2 = { class: "static-main-container h-full" }
const _hoisted_3 = { class: "title-container flex justify-content-center align-items-center" }
const _hoisted_4 = { class: "cursor-pointer fixed bottom-0 right-0 p-3 flex gap-2 text-white" }

import { computed, ref } from "vue";
import StaticFooter from "./footer.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mainContainer = ref<HTMLElement | null>(null);
const scrollY = ref(0);

const isAtTop = computed(() => scrollY.value === 0);
const isAtBottom = computed(() => {
  if (!mainContainer.value) return false;

  return mainContainer.value.offsetHeight + scrollY.value >= mainContainer.value.scrollHeight;
});

const onScroll = (e: any) => (scrollY.value = e.target.scrollTop);
const scrollAuto = (scrollTop: number) => mainContainer.value?.scrollTo({ top: scrollTop, behavior: "smooth" });
const scrollUp = () => scrollAuto(0);
const scrollDown = () => scrollAuto(mainContainer.value?.scrollHeight || 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "static-layout-container relative overflow-scroll",
    ref_key: "mainContainer",
    ref: mainContainer,
    onScroll: onScroll
  }, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", null, [
            _renderSlot(_ctx.$slots, "title")
          ])
        ]),
        _renderSlot(_ctx.$slots, "content")
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_4, [
      (!_unref(isAtBottom))
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "pi pi-arrow-down p-2 bg-orange-500 border-circle shadow-3",
            onClick: scrollDown
          }))
        : _createCommentVNode("", true),
      (!_unref(isAtTop))
        ? (_openBlock(), _createElementBlock("i", {
            key: 1,
            class: "pi pi-arrow-up p-2 bg-orange-500 border-circle shadow-3",
            onClick: scrollUp
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(StaticFooter)
  ], 544))
}
}

})